import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "../../../views/ReportView/ReportView.module.css";
import { FaRegAddressCard } from "react-icons/fa";
import NotReportViewData from "../../NotReportViewData/NotReportView";
import { FaUserAlt } from "react-icons/fa";
import axios from "axios";
import Swal from "sweetalert2";
import { BajaButton, AltaButton } from "../../";

const HeaderReview = ({ data }) => {
  const [user, setUser] = useState(data);
  const navigate = useNavigate();

  const handleEditUser = async (e, dni) => {
    e.preventDefault();
    try {
      const res = await axios.post(process.env.REACT_APP_UPDATE_USER_API, {
        id: dni,
      });

      if (res.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Exito",
          text: "El usuario se actualizo correctamente",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: error.response.data.message,
      });
    }
  };

  const handlerNavigateUpdate = (e, data) => {
    e.preventDefault();
    navigate("/informe/actualizar", { state: { data } });
  };

  const handlePdf = (e, data) => {
    e.preventDefault();
    navigate("/informe/imprimir-pdf", { state: { data } });
  };

  const changeColoResult = () => {
    if (user.Risk.data === "Riesgo bajo") {
      return (
        <div className={styles.mdrResult}>
          <h4>Resultado del perfil:</h4>
          <p className={styles.mdrlow}>{user.Risk.data}</p>
        </div>
      );
    } else if (user.Risk.data === "Riesgo medio") {
      return (
        <div className={styles.mdrResult}>
          <h4>Resultado del perfil:</h4>
          <p className={styles.mdrmid}>{user.Risk.data}</p>
        </div>
      );
    } else {
      return (
        <div className={styles.mdrResult}>
          <h4>Resultado del perfil:</h4>
          <p className={styles.mdrheig}>{user.Risk.data}</p>
        </div>
      );
    }
  };

  return (
    <div className={styles.Info}>
      {!user ? (
        <NotReportViewData title="Información" Icon={FaUserAlt} />
      ) : (
        <>
          <div className={styles.sectionTitle}>
            <div>
              <h2 className={styles.title}>
                <FaRegAddressCard className={styles.icon} /> {user.cuil} |
                {" " + user.name} {user.lastName}
              </h2>
            </div>
            <div className={styles.buttonsContainerfelx}>
              <div className={styles.buttonsContainer}>
                {user.status === "Alta" ? (
                  <BajaButton user={user} setUser={setUser} />
                ) : (
                  <AltaButton user={user} setUser={setUser} />
                )}
              </div>
              <div className={styles.buttonsContainer}>
                <button
                  className={styles.button}
                  onClick={(e) => handlePdf(e, data)}
                >
                  <i className="fa fa-refresh"></i> Imprimir Informe
                </button>
              </div>
              <div className={styles.buttonsContainer}>
                <button
                  className={styles.button}
                  onClick={(e) => handleEditUser(e, user.dni)}
                >
                  <i className="fa fa-refresh"></i> Actualizar por Nosis
                </button>
              </div>
              <div className={styles.buttonsContainer}>
                <button
                  id={styles.idbuton}
                  className={styles.button}
                  onClick={(e) => handlerNavigateUpdate(e, user)}
                >
                  <i className="fa fa-refresh"></i> Actualizar a Mano
                </button>
              </div>
            </div>
          </div>
          {changeColoResult()}
        </>
      )}
    </div>
  );
};

export default HeaderReview;
